( function( ) {
	var _targetId = 0,
		_userStageId = 0,
		_supporterStageId = 0,
		btn,
		rootUrl;
	
	const _supporterNames = ['my-experience', 'my-child', 'my-partner', 'my-family-member', 'my-friend'], // URL keys that coorrelate to _targetId
		_myStageRoot = 'stage-', // URL key that will get _userStageId appeneded to
		_supporterStages = ['might-be-using', 'is-using', 'might-relapse'], // URL keys that coorrelate to _supporterStageId
		NEXT = 'next', SHOW = 'show';
	
	document.addEventListener( 'DOMContentLoaded', function() {
		var filterEle = document.querySelector( '.filter-container' );
		btn = filterEle.querySelector( '.build-experience' );
		var optionsEle = filterEle.querySelectorAll( '#switch-myself, #switch-someone-else' );
		
		if( !filterEle || !btn || !optionsEle.length ) { return; }
		
		var filterMyself = document.getElementById( 'filters-myself' ),
			filterSomeoneElse = document.getElementById( 'filters-someone-else' ),
			checkMyself = document.getElementById( 'switch-myself' ),
			checkSomeoneElse = document.getElementById( 'switch-someone-else' );
		
		rootUrl = btn.getAttribute( 'href' );
		
		// clear by default
		filterEle.querySelector( 'input' ).checked = false;
		
		// Handle Checkboxes - show the corresponding options
		checkMyself.addEventListener( 'change', function() {
			if( this.checked ) {
				// TODO: Possibly adding/removing a class instead of setting the display thru CSS
				filterMyself.style.display = 'block';
				filterSomeoneElse.style.display = 'none';
				_targetId = 1;
				
				setTimeout( function() {
					filterEle.classList.add( NEXT );
				}, 500 );
			}
		} );
		
		checkSomeoneElse.addEventListener( 'change', function() {
			if( this.checked ) {
				filterSomeoneElse.style.display = 'block';
				filterMyself.style.display = 'hide';
				_targetId = 2;
				
				setTimeout( function() {
					filterEle.classList.add( NEXT );
				}, 500 );
			}
		} );
		
		// Handle selects - update the destination link
		filterMyself.querySelector( 'select' ).addEventListener( 'change', function () {
			_userStageId = parseInt( this.value );
			setMyExperienceLink();
		} );
		
		var someoneElseEle = filterSomeoneElse.querySelectorAll( 'select' );
		
		someoneElseEle.forEach( select => { 
			select.addEventListener( 'change', function () {
				_targetId = parseInt( someoneElseEle[0].value );
				_supporterStageId = parseInt( someoneElseEle[someoneElseEle.length - 1].value );

				if( _targetId && _supporterStageId ) {
					setMyExperienceLink();
				} else {
					btn.classList.remove( SHOW );
				}
			} );
		} );
		
		// Allow a user to go back to the initial checkboxes
		filterEle.querySelector( '.filter-back-link' ).addEventListener( 'click', function( e ) {
			e.preventDefault();
			
			// Reset
			filterEle.querySelector( 'input' ).checked = false;
			_targetId = 0;
			_userStageId = 0;
			_supporterStageId = 0;
			
			setTimeout( function() {
				filterEle.classList.remove( NEXT );
			}, 250 );
		} );
		
		// Set a cookie once a destination is selected
		btn.addEventListener( 'click', function() {
			window.SYR.SiteFilter.setTarget( _targetId );
			window.SYR.SiteFilter.setUserStage( _userStageId );
			window.SYR.SiteFilter.setSupporterStage( _supporterStageId );
			window.SYR.SiteFilter.save();
		} );
	} );
	
	function isBetween( val, min, max ) {
		return ( min <= val ) && ( val <= max );
	}
	
	function setMyExperienceLink() {
		var href = '';
		
		if( _targetId ) {
			href = rootUrl + _supporterNames[_targetId - 1] + '/';
		}
		
		if( _targetId === 1 && isBetween( _userStageId, 1, 5 ) ) {
			// "Myself" experiences
			href += _myStageRoot + _userStageId;
		} else if( isBetween( _targetId, 2, _supporterNames.length + 1 ) && isBetween( _supporterStageId, 1, _supporterStages.length ) ) {
			// "Someone else" experiences
			href += _supporterStages[_supporterStageId - 1];
		}
		
		if ( href.length ) {
			window.SYR.createCookie( window.SYR.HOME_PAGE_COOKIE, href );	
			btn.setAttribute( 'href', href );
			btn.classList.add( SHOW );
		} else {
			btn.classList.remove( SHOW );
		}
	}
} )( );